/* eslint-disable */
import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { TableSortLabel, Container, Button } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import dayjs from 'dayjs';
import addCommas from '../utils/functions/commas';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DetailStoreManagement from '../components/StoreManagement/DetailStoreManagement';
import EditStoreManagement from '../components/StoreManagement/EditStoreManagement';
import DeleteStoreManagement from '../components/StoreManagement/DeleteStoreManagement';

const columns = [
  {
    width: '100px',
  },
  {
    id: 'merchant_name',
    label: 'ชื่อร้านค้า',
    align: 'left',
  },
  {
    id: 'action',
    label: ' ',
    align: 'center',
    minWidth: 200,
  },
];

function TableStoreManagement({
  isstoreManagementSuperAdmin,
  pagination,
  handlePaginationChange,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(pagination.currPage - 1);
  const [rowsPerPage, setRowsPerPage] = useState(pagination.size);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setRowsPerPage(newSize);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', newSize);
  };

  const [DetailStoreManagementPopupOpen, setDetailStoreManagementPopupOpen] =
    useState(false);

  const [EditStoreManagementPopupOpen, setEditStoreManagementPopupOpen] =
    useState(false);

  const [DeleteStoreManagementPopupOpen, setDeleteStoreManagementPopupOpen] =
    useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  const handleOpenDetailStoreManagementPopupOpen = (row) => {
    setSelectedRow(row);
    setDetailStoreManagementPopupOpen(true);
  };
  const handleOpenEditStoreManagementPopupOpen = (row) => {
    setSelectedRow(row);
    setEditStoreManagementPopupOpen(true);
  };
  const handleOpenDeleteStoreManagementPopupOpen = (row) => {
    setSelectedRow(row);
    setDeleteStoreManagementPopupOpen(true);
  };

  const handleCloseDetailStoreManagementPopupOpen = () => {
    setDetailStoreManagementPopupOpen(false);
    setSelectedRow(null);
  };
  const handleCloseEditStoreManagementPopupOpen = () => {
    setEditStoreManagementPopupOpen(false);
    setSelectedRow(null);
  };
  const handleCloseDeleteStoreManagementPopupOpen = () => {
    setDeleteStoreManagementPopupOpen(false);
    setSelectedRow(null);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(isstoreManagementSuperAdmin) ? (
            <TableBody>
              {isstoreManagementSuperAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                    className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      {row.name ? row.name : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        sx={{
                          color: '#0F4898',
                        }}
                        onClick={() =>
                          handleOpenDetailStoreManagementPopupOpen(row)
                        }
                      >
                        <RemoveRedEyeIcon />
                      </IconButton>
                      <IconButton
                        sx={{
                          color: '#F4BA27',
                        }}
                        onClick={() =>
                          handleOpenEditStoreManagementPopupOpen(row)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        sx={{
                          color: '#FC3A3A',
                        }}
                        onClick={() =>
                          handleOpenDeleteStoreManagementPopupOpen(row)
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={10} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <DetailStoreManagement
        open={DetailStoreManagementPopupOpen}
        onClose={handleCloseDetailStoreManagementPopupOpen}
        data={selectedRow}
      />
      <EditStoreManagement
        open={EditStoreManagementPopupOpen}
        onClose={handleCloseEditStoreManagementPopupOpen}
        data={selectedRow}
      />
      <DeleteStoreManagement
        open={DeleteStoreManagementPopupOpen}
        onClose={handleCloseDeleteStoreManagementPopupOpen}
        deleteId={selectedRow}
      />
    </>
  );
}

export default TableStoreManagement;
